export default __webpack_public_path__ + "static/illustration-periodic-elements-533a1f674da7002d2c5c91fbee60e8dd.svg";